import { useState } from "react";
import { useGlobalContext } from "../../../context";
import Tooltip from "../../widgets/Tooltip";
import {
  Card,
  CrearNota,
  CrearNotaHover,
  List,
  PersonInfo,
  Bullet,
  NormalInputsFields,
  ModalButtons,
} from "./NotesElements";

// widgets
import Scrollbar from "../../widgets/Scrollbar";

//date formatting
import { formatDate } from "../../../utils/FormatDates";
import UserImage from "../../svg/UserImage";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import TranslatableText from "../../Multilanguage/TranslatableText";

const MAX_CHARS = 1000;

const processText = (text) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  const result = text.replace(
    urlRegex,
    (url) =>
      '<a target="_balnk" href="' +
      url.replace("</p>", "") +
      '">' +
      url +
      "</a>"
  );

  return result;
}

export const Crear = ({ setModal, modal }) => {
  const [hover, setHover] = useState(false);
  const { t } = useTranslation()

  return (
    <Tooltip title={t("requestDetail.tabNotes.createNote")}>
      <button
        className="focus:outline-none"
        onClick={() => {
          setModal(true);
          setHover(false);
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {hover ? <CrearNotaHover /> : <CrearNota />}
      </button>
    </Tooltip>
  );
};

export const Note = ({ note }) => {
  const { secundaryColor, color7 } = useGlobalContext();
  const { t } = useTranslation()
  return (
    <Card bg={secundaryColor} className={`my-2 w-full rounded-lg py-4 sm:p-8`}>
      <TranslatableText className="w-full break-words text-space font-semibold px-8 sm:px-6" text={processText(note.Description)} format="html" style={{overflowWrap: "break-word", width: "90%", overflow: "hidden", whiteSpace: "pre-wrap"}} />
      {/* <div className="w-full break-words text-space font-semibold px-8 sm:px-6" dangerouslySetInnerHTML={{ __html: processText(note.Description) }} style={{overflowWrap: "break-word", width: "90%", overflow: "hidden", whiteSpace: "pre-wrap"}}>
      </div> */}
      <div className={` h-5/6 bg-space self-center`}></div>
      <PersonInfo className="w-full px-4 sm:px-16">
        <UserImage note={note} />
        <div className={`pt-2`}>
          <h1 className={`text-md text-${color7} font-title mb-2.5`}>
            {note.UserName}{" "}
          </h1>
          <List>
            <li className="flex flex-row gap-1 relative">
              <Bullet />
              <p className="font-body text-sm sm:text-md">
                <TranslatableText text={note.NoteTypeName} />
              </p>
            </li>
            <li className="flex flex-row gap-1 relative">
              <Bullet />
              <p className="font-body text-sm sm:text-md">{t("requestDetail.tabNotes.notes")} {note.ID}</p>
            </li>
            <li className="flex flex-row gap-1 relative">
              <Bullet />
              <p className="font-body text-sm sm:text-md">
                {formatDate(note.NoteDate)}
              </p>
            </li>
          </List>
        </div>
      </PersonInfo>
    </Card>
  );
};

export const Confirm = (props) => {
  const {
    noteType,
    setModalActive,
    requestState,
    description,
    setDescription,
    handleCreateNote,
    handleNoteType,
  } = props;

  const { t } = useTranslation()

  const customStyles = {
    option: (provided) => ({
      ...provided,
    }),
    control: (provided) => ({
      ...provided,
      display: "flex",
      border: "1px solid #dce6e6",
      borderRadius: "7px",
      width: "100%",
      margin: "0",
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    placeholder: () => ({
      display: "none",
    }),
  };

  return (
    <div className="flex flex-col gap-2 h-full w-full">
      <div className="p-4 h-full w-full">
        <Scrollbar height="100%">
          <div className="flex flex-col h-full p-4 gap-4">
            <NormalInputsFields>
              <label className="w-36 font-medium">
                {t("requestDetail.tabNotes.typeNote")}{" "}
                <span style={{ color: "red" }}>*</span>
              </label>
              <Select
                defaultValue={noteType}
                onChange={(e) => handleNoteType(e)}
                options={requestState.notesTypes.map((data) => {
                  return {...data, label: <TranslatableText text={data.label} />}
                })}
                styles={customStyles}
              />
            </NormalInputsFields>
            <div className="w-full flex flex-col">
              <label className="w-36 font-medium">
                {t("requestDetail.tabNotes.description")}{" "}
                <span style={{ color: "red" }}>*</span>
              </label>
              <textarea
                className="border border-gray-300 rounded-md mx-1 p-2 w-full focus:border-blue-400 z-0"
                value={description}
                maxLength={1000}
                placeholder={t("requestDetail.tabNotes.descriptionPlaceholder")}
                rows={"6"}
                cols={"50"}
                onChange={(e) => setDescription(e.target.value)}
              />
              <span
                className="mt-1 ml-1"
                style={{
                  color: description.length >= MAX_CHARS ? "red" : "#323246",
                  fontSize: "0.850rem",
                }}
              >{`${description.length}/${MAX_CHARS}`}</span>
            </div>
          </div>
        </Scrollbar>
      </div>
      <div className="flex justify-center items-center gap-8">
        <ModalButtons
          onClick={() => {
            setModalActive(false);
          }}
        >
          {t("requestDetail.cancel")}
        </ModalButtons>
        <ModalButtons
          bg="#00B446"
          onClick={() => {
            handleCreateNote();
            setModalActive(false);
          }}
        >
          {t("requestDetail.create")}
        </ModalButtons>
      </div>
    </div>
  );
};
